import { Drawer, Box, Typography, IconButton, Stack, Divider, Avatar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import { useSelector } from 'react-redux';
import { STAGES } from '../constants';

export default function HelpDrawer({ open, onClose }) {
  const stage = useSelector((s) => s.tatWizard.stage);
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: 420, maxWidth: '90vw' } }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1.25}
        sx={{ px: 2.25, py: 1.75, borderBottom: 1, borderColor: 'divider' }}
      >
        <Avatar variant="rounded" sx={{ width: 26, height: 26, bgcolor: 'primary.lighter', color: 'primary.dark' }}>
          <MenuBookOutlinedIcon sx={{ fontSize: 14 }} />
        </Avatar>
        <Typography variant="subtitle2" sx={{ fontSize: 14, fontWeight: 700, flex: 1 }}>
          Help · what each stage does
        </Typography>
        <IconButton size="small" onClick={onClose}><CloseIcon fontSize="small" /></IconButton>
      </Stack>
      <Box sx={{ p: 2.25, overflow: 'auto', flex: 1 }}>
        {STAGES.map((s) => (
          <Box key={s.id} sx={{ mb: 2 }}>
            <Typography variant="subtitle2" sx={{ fontSize: 12.5, fontWeight: 700, color: s.id === stage ? 'primary.dark' : 'text.primary' }}>
              Stage {s.id + 1} · {s.label}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.4, fontSize: 12.5, lineHeight: 1.55 }}>
              {s.explainer}
            </Typography>
            <Divider sx={{ mt: 1.5 }} />
          </Box>
        ))}
      </Box>
    </Drawer>
  );
}
